import Vue from 'vue';

export default {
    name: 'string-content',
    props: {
        content: {
            type: Object,
            default: null
        },
        contentRef: {
            type: Object,
            default: null
        },
        field: {
            type: String,
            default: 'data'
        },
        tag: {
            type: String
        }
    },
    render(createElement) {
        let content = this.content;

        if (!content && this.contentRef && this.contentRef.contentId) {
            content = Vue.state.content.strings.getById(this.contentRef.contentId);
        }

        if (!content) return createElement('');

        if (this.field == 'title') {
            return createElement(this.tag || 'span', content.title);
        } else if (content.type == 'html' || content.type == 'wysiwyg') {
            return createElement(this.tag || 'div', { domProps: { innerHTML: content.data } });
        } else {
            return createElement(this.tag || 'div', content.data);
        }
    }
};



// WEBPACK FOOTER //
// ./_common/components/content/string-content.js